var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DMorphLines9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1402,
    height: 295,
    viewBox: "0 0 1402 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.02 2.7803C659.283 2.28453 827.546 1.69108 995.808 1C1064.86 50.7577 1111.93 122.69 1197.9 143.423C1271.01 161.09 1332.82 176.594 1400 213.282C919.97 212.741 439.97 212.741 -40 213.282C6.49014 194.014 52.3944 174.138 102.67 168.211C143.639 163.299 184.563 168.527 225.577 166.093C338.501 159.265 402.366 59.7944 491.02 2.7803Z",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3068 171.819C283.234 191.717 485.645 246.027 693.51 244.179C901.374 242.331 1103.38 186.016 1309.71 169.024",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.3 165.711C338.821 214.004 519.914 301.576 703.891 292.179C889.491 282.714 1064.07 196.742 1242.48 152.686",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.785 165.712C385.875 221.532 545.763 299.887 712.073 288.213C878.856 276.473 1033.79 193.971 1190.29 142.14",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.434 153.995C425.538 197.736 572.152 252.7 718.586 240.102C866.62 227.37 1007.62 169.928 1148.72 127.426",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.187 129.789C460.737 160.46 591.824 192.122 723.993 182.679C856.77 173.192 985.852 135.851 1114.8 105.203",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M370.458 101.282C489.196 120.752 607.979 135.986 728.52 130.443C849.061 124.899 967.979 101.395 1086.58 80.9778",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402.007 73.4765C625.105 96.0117 840.655 83.8202 1062.76 58.1526",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M429.032 49.027C633.922 60.1369 837.866 52.9031 1042.4 38.3904",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M452.377 28.9886C643.093 33.2928 834.078 29.597 1024.77 22.228",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M472.923 13.6891C651.695 14.4778 830.557 12.9004 1009.26 9.94824",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M949.577 1.1582C999.493 52.561 1035.73 151.153 1108.16 174.364C1130.87 181.665 1153.23 177.744 1176.37 179.547C1212.43 182.364 1236.72 193.068 1266.74 213.102",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M903.469 1.33887C928.888 42.06 945.452 82.9614 965.44 126.544C974.274 145.767 994.376 198.657 1018.78 208.911C1062.39 227.299 1086.68 182.071 1134.07 213.147",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M857.43 1.51953C873.204 46.8153 884.855 92.5167 896.123 139.21C900.427 157.012 911.086 233.227 929.632 242.038C958.59 255.807 974.703 182.027 1001.75 213.238",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M811.427 1.67822C818.683 57.0698 823.731 112.551 828.711 168.191C831.731 201.994 831.078 241.656 843.652 273.746C852.013 260.991 854.041 210.963 870.041 213.306",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M765.474 1.81421C759.908 97.7691 764.685 197.758 750.736 292.879C745.801 272.733 752.584 227.527 738.68 213.285",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M719.602 1.90234C703.241 67.6376 695.376 133.102 684.176 199.897C682.396 210.578 676.83 288.212 663.692 293.373C634.509 304.866 640.729 211.57 607.782 213.283",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M673.785 1.9458C648.073 59.1176 633.582 118.047 616.658 178.103C613.03 190.949 597.616 267.546 575.554 278.926C533.887 300.38 523.723 189.168 477.323 213.303",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M628.01 2.21948C590.264 57.0251 570.501 117.938 542.895 177.994C535.413 194.265 511.639 254.366 487.661 261.262C434.974 276.405 404.822 174.253 347.289 213.194",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M582.286 2.42114C539.469 47.4916 513.238 101.711 479.187 153.249C460.438 181.621 436.212 223.108 399.998 230.365C368.314 236.607 339.536 214.725 310.443 205.711C275.559 194.894 250.545 197.689 217.711 213.103",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M536.644 2.646C468.16 58.3981 409.568 188.314 312.667 198.139C276.115 201.835 239.54 187.592 203.191 185.542C161.32 183.176 126.165 194.961 88.6443 213.102",
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.679825,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DMorphLines9);
export default __webpack_public_path__ + "static/media/3D Morph Lines 9.40fee4ebf8717b79fdb34c8cd713da88.svg";
export { ForwardRef as ReactComponent };